import React from "react";
import './styles/CommonStyles.css';

export default function DashboardHeader({
  title="Dashboard",
  subtitle=""
}) {
  return (
    <header className="header-dashboard">
      <h1>{title}</h1>
      <p>{subtitle}</p>
    </header>
  );
}
